import './common'

window.addEventListener('scroll', () => {
  const point1BalloonDOM = document.querySelector('section.points .point1 .balloon')
  const point2BalloonDOM = document.querySelector('section.points .point2 .balloon')
  const point3BalloonDOM1 = document.querySelector('section.points .point3 .balloon1')
  const point3BalloonDOM2 = document.querySelector('section.points .point3 .balloon2')
  const point3BalloonDOM3 = document.querySelector('section.points .point3 .balloon3')
  const alexaBalloonDOM = document.querySelector('section.how-to .animation .balloon')

  const point1TabletDOM = document.querySelector('section.points .point1 .tablet')
  const point2TabletDOM = document.querySelector('section.points .point2 .tablet')
  const point3TabletDOM = document.querySelector('section.points .point3 .tablet')
  const alexaBottomLineDOM = document.querySelector('section.how-to hr')

  const windowPageYOffset = window.pageYOffset

  const point1TabletDOMAbsoluteBottomY = point1TabletDOM.getBoundingClientRect().bottom + windowPageYOffset
  const point2TabletDOMAbsoluteBottomY = point2TabletDOM.getBoundingClientRect().bottom + windowPageYOffset
  const point3TabletDOMAbsoluteBottomY = point3TabletDOM.getBoundingClientRect().bottom + windowPageYOffset
  const alexaBottomLineDOMAbsoluteBottomY = alexaBottomLineDOM.getBoundingClientRect().bottom + windowPageYOffset

  const screenBottomAbsoluteY = (window.scrollY || pageYOffset) + window.innerHeight
  const windowWidth = window.innerWidth;

  if (screenBottomAbsoluteY > point1TabletDOMAbsoluteBottomY + 0 / 750 * windowWidth) {
    point1BalloonDOM.classList.add('active')
  }

  if (screenBottomAbsoluteY > point2TabletDOMAbsoluteBottomY + 0 / 750 * windowWidth) {
    point2BalloonDOM.classList.add('active')
  }

  if (screenBottomAbsoluteY > point3TabletDOMAbsoluteBottomY + 0 / 750 * windowWidth) {
    point3BalloonDOM1.classList.add('active')

    setTimeout(() => {
      point3BalloonDOM2.classList.add('active')
    }, 200)

    setTimeout(() => {
      point3BalloonDOM3.classList.add('active')
    }, 400)
  }

  if (screenBottomAbsoluteY > alexaBottomLineDOMAbsoluteBottomY + 0 / 750 * windowWidth) {
    alexaBalloonDOM.classList.add('active')
  }
})
